export default __webpack_public_path__ + "static/Iulia_V1@2x-ad99785c1b1cfaa7376bf5c81bb87f27.png";